module.exports = __webpack_public_path__ + "img/cupweb.6377c888.webp";